export function nl2br(str) {
  return str.replace(/(\n)/g, '<br />')
}
export function 改行2nl(str) {
  return str.replace(/{改行}/g, "\n")
}
